module.exports = __webpack_public_path__ + "img/orange_011.e983464f.png";